import { Http } from '../../shared';
import { settings } from '../../settings';

export class UserService {
    constructor() {
        this.http = new Http();
        this.service_url = `${settings.admin_api}/users`;
    }

    async find(id) {
        var options = {
            headers: {
                'Content-Type': 'application/json'
            }
        }
        var response = await this.http.get(`${this.service_url}/${id}`, options);
        return response.data;
    }
    async search(query) {
        var options = {
            headers: {
                'Content-Type': 'application/json'
            },
            params: query
        }
        var response = await this.http.get(`${this.service_url}`, options);
        var result = {
            data: response.data,
            page_size: response.headers['x-pagination-page-size'],
            page_number: response.headers['x-pagination-page-number'],
            total_size: response.headers['x-pagination-total-size'],
        };
        return result;
    }
    async create(data) {
        var options = {
            headers: {
                'Content-Type': 'application/json'
            }
        }

        var response = await this.http.post(`${this.service_url}`, data, options);
        return response.data;
    }
    async update(id, data) {
        var options = {
            headers: {
                'Content-Type': 'application/json'
            }
        }

        var response = await this.http.put(`${this.service_url}/${id}`, data, options);
        return response.data;
    }
    async delete(id) {
        var options = {
            headers: {
                'Content-Type': 'application/json'
            }
        }

        var response = await this.http.delete(`${this.service_url}/${id}`, {}, options);
        return response.data;
    }
    async getRoles(id) {
        var options = {
            headers: {
                'Content-Type': 'application/json'
            }
        }
        var response = await this.http.get(`${this.service_url}/${id}/roles`, options);
        var result = {
            data: response.data,
            page_size: response.headers['x-pagination-page-size'],
            page_number: response.headers['x-pagination-page-number'],
            total_size: response.headers['x-pagination-total-size'],
        };
        return result;
    }
    async saveRoles(id, data) {
        var options = {
            headers: {
                'Content-Type': 'application/json'
            }
        }

        var response = await this.http.post(`${this.service_url}/${id}/roles`, data, options);
        return response.data;
    }
}
